export const customNumberHandleChange = (value) => {
  const numericValue = value.replace(/[^0-9]/g, '');
  return Number(numericValue)
}
